module.exports = __webpack_public_path__ + "static/media/ic_menu.155b9357.svg";